import type { BaseTranslation } from '../i18n-types';

export const call = {
    incomingCall: 'Incoming call',
    outgoingCall: 'Outgoing call',
    cancel: 'Cancel',
    answer: 'Answer',
    doesntAnswer: {
        title: '{displayName:string} doesn\'t answer',
        subtitle: 'They might be busy now. Please try calling again later',
        buttonText: 'Start random chat',
    },
    dropdownTitle: 'Incoming calls',
    dropdownSubtitle: 'Turn off if you want to mute calls for 30 minutes',
} satisfies BaseTranslation;

